import React from "react"
import { compose, withProps } from "recompose"
import {
  GoogleMap as ReactGoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs,
} from "react-google-maps"
import PropTypes from "prop-types"

export const GoogleMap = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?&v=3.exp&libraries=geometry,drawing,places&key=${process.env.GOOGLE_API_KEY}`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div className="gallery-wrapper" />,
    mapElement: <div style={{ height: `100%`, width: "100%" }} />,
  }),
  withScriptjs,
  withGoogleMap
)(({ lat, lng }) => (
  <ReactGoogleMap
    defaultZoom={15}
    defaultCenter={{ lat: lat || -6.19011, lng: lng || 106.823655 }}
  >
    <Marker position={{ lat: lat, lng: lng }} />
  </ReactGoogleMap>
))

export const GoogleMapsEmbed = ({
  embedUrl,
  className = 'map-w-100 map-h-600'
}) => {
  return(
    <div 
      className={embedUrl === null ? "d-none" : className } 
      dangerouslySetInnerHTML={{__html: embedUrl}} 
    ></div>
  )
}

GoogleMapsEmbed.propTypes = {
  embedUrl: PropTypes.string,
}

GoogleMapsEmbed.defaultProps = {
  embedUrl: "",
}


export const LlvGoogleMapsEmbed = ({
  embedUrl
}) => {
  return(
    <div 
      className={embedUrl === null ? "d-none" : "map-w-100 " } 
      dangerouslySetInnerHTML={{__html: embedUrl}} 
    ></div>
  )
}

LlvGoogleMapsEmbed.propTypes = {
  embedUrl: PropTypes.string,
}

LlvGoogleMapsEmbed.defaultProps = {
  embedUrl: "",
}
